import { Card, CardBody, Col } from "reactstrap";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import { withIndicatorData, withIndicatorDataList } from "../../../../Data/BonusUi/Carousel";
import { dynamicImage } from "../../../../Utils";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { WithIndicator } from "../../../../Utils/Constants";

const WithIndicators = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CardHeaderCommon title={WithIndicator} span={withIndicatorData} />
        <CardBody>
          <Swiper pagination={{ clickable: true }} navigation modules={[Pagination, Navigation]}>
            {withIndicatorDataList.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(item.image)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithIndicators;
